
import Vue from 'vue'
import BaseButton from './BaseButton.vue'
export default Vue.extend({
   name: 'StandardButton',
   props: {
      label: { default: 'Process', type: String },
      actionLabel: { default: 'Processing', type: String },
      showIcon: { default: false, type: Boolean },
      icon: { default: 'glyphicon-ok', type: String },
      type: { default: 'btn-default', type: String },
      size: { default: '', type: String },
      block: { default: '', type: String },
      enabled: { default: true, type: Boolean },
      processing: { default: false, type: Boolean },
   },
   components: {
      BaseButton,
   },
})
